import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

Vue.component("vue-dropzone", vue2Dropzone);

Vue.component("calendar", () => import("./tracker/Calendar.vue"));

Vue.component("date-range", () => import("./tracker/DateRange.vue"));

Vue.component("term-range", () => import("./tracker/TermRange.vue"));

Vue.component("date-recurring", () => import("./tracker/DateRecurring.vue"));

var VueAutosize = () => import("vue-autosize");
Vue.use(VueAutosize);

Vue.component(
  "expandable-textarea",
  () => import("./tracker/ExpandableTextarea.vue")
);
Vue.component("plan-actions", () => import("./tracker/PlanActions.vue"));

Vue.component("activity-import", () => import("./tracker/ActivityImport.vue"));


Vue.component("plan-download", () => import("./tracker/PlanDownload.vue"));
Vue.component("plan-duplicate", () => import("./tracker/PlanDuplicate.vue"));
Vue.component(
  "activity-date-options",
  () => import("./tracker/ActivityDateOptions.vue")
);
Vue.component(
  "activity-add-students",
  () => import("./tracker/ActivityAddStudents.vue")
);
Vue.component(
  "activity-provider-details",
  () => import("./tracker/ActivityProviderDetails.vue")
);

Vue.component(
  "review-to-complete-benchmark1",
  () => import("./tracker/ReviewToCompleteBenchmark1.vue")
);
Vue.component("review-to-complete", () => import("./tracker/ReviewToComplete.vue"));
Vue.component("validation-error", () => import("./tracker/ValidationError.vue"));
Vue.component(
  "validation-error-multi",
  () => import("./tracker/ValidationErrorMulti.vue")
);

Vue.component(
  "school-activity-summary",
  () => import("./tracker/SchoolActivitySummary.vue")
);

Vue.component(
  "tr-summary-basic-details",
  () => import("./tracker/summary/trSummaryBasicDetails.vue")
);

Vue.component("school-plan", () => import("./tracker/SchoolPlan.vue"));
Vue.component("year-groups", () => import("./tracker/plan/YearGroups.vue"));
Vue.component(
  "tr-expanded-details",
  () => import("./tracker/plan/TrExpandedDetails.vue")
);
Vue.component("tr-basic-details", () => import("./tracker/plan/TrBasicDetails.vue"));
Vue.component(
  "tr-expanded-options",
  () => import("./tracker/plan/TrExpandedOptions.vue")
);

Vue.component("restricted-input", () => import("./tracker/RestrictedInput.vue"));
Vue.component("scroll-to-top", () => import("./tracker/ScrollToTop.vue"));
Vue.component("cancel-activity-form", () => import("./tracker/plan/CancelActivityForm"));
